import { createFileRoute } from "@tanstack/react-router";

import { VIDEO_CHECKER_FAQS } from "@/components/marketing/video-checker-faqs";
import { VideoCheckerTool } from "@/components/marketing/video-checker-tool";
import { toolPageHead } from "@/lib/seo";

/**
 * `head` is never code-split, so it must not reach into the component module —
 * that would drag the whole tool into the shared entry chunk. The FAQs live in
 * their own module for exactly this reason; see `video-checker-faqs.ts`.
 */
export const Route = createFileRoute("/(public)/tools/video-checker")({
  head: () => toolPageHead("videoChecker", VIDEO_CHECKER_FAQS),
  component: VideoCheckerTool,
});
